<script setup>
import Header from './Header.vue'
const email = "<span class='font-mono'>admin@domain</span>";
</script>
<template>
<div class="container mx-auto mb-8 px-2 lg:px-0 lg:w-1/2">

<Header />

<h1>Community Board Profiles</h1>
<p>
    These board profiles have been submitted by the community and can be used
    by clicking on import/export and pasting the json into the text-area in the 
    board color preferences. If you want to contribute a board profile, please
    send us an email.
</p>

<div>
    <h2>
        Noir <span class="font-normal"> by Deinonychus</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#1f1f1f",
  "field": "#191919",
  "highlight": "#FF7C00",
  "point_b": "#383838",
  "point_w": "#919191",
  "stone_b": "#464646",
  "stone_w": "#f5f5f5"
}
    </pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/void_deinonychus.png">
    </div>
</div>

<div>
    <h2>
        Habs <span class="font-normal">by Orad</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#192168",
  "field": "#FFFFFF",
  "highlight": "#FF7C00",
  "point_b": "#c87379",
  "point_w": "#366ad5",
  "stone_b": "#ac1b2b",
  "stone_w": "#d8cfd9"
}
</pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/habs_orad.png">
    </div>
</div>

<div>
    <h2>
        Sweets <span class="font-normal">by Domek</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#000000",
  "field": "#cc85cc",
  "highlight": "#FF7C00",
  "point_b": "#ab6dab",
  "point_w": "#f7bcf7",
  "stone_b": "#cc3333",
  "stone_w": "#ffff45"
}
</pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/sweets_domek.jpg">
    </div>
</div>


<div>
    <h2>
        Minimalist <span class="font-normal"> by Deinonychus</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#0d0d0d",
  "field": "#000000",
  "highlight": "#FF7C00",
  "point_b": "#000000",
  "point_w": "#000000",
  "stone_b": "#e80000",
  "stone_w": "#f5f5f5"
}
    </pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/minimalist_deinonychus.png">
    </div>
</div>


<div>
    <h2>
        Cricket <span class="font-normal">by Domek</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#1E2129",
  "field": "#558a55",
  "highlight": "#FF7C00",
  "point_b": "#4c7a4c",
  "point_w": "#609c60",
  "stone_b": "#7d0006",
  "stone_w": "#e8b47d"
}
</pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/cricket_domek.jpg">
    </div>
</div>

<div>
    <h2>
        Caramel <span class="font-normal">by Domek</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#291b00",
  "field": "#9e7c00",
  "highlight": "#FF7C00",
  "point_b": "#804d00",
  "point_w": "#e3a600",
  "stone_b": "#750006",
  "stone_w": "#edd7a8"
}
</pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/caramel_domek.jpg">
    </div>
</div>


<div>
    <h2>
        Cork <span class="font-normal">by Gwnn</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#1a3889",
  "field": "#bd9261",
  "highlight": "#FF7C00",
  "point_b": "#0d0070",
  "point_w": "#ffffff",
  "stone_b": "#443285",
  "stone_w": "#cdcccb"
}
</pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/cork_gwnn.png">
    </div>
</div>

<div>
    <h2>
        UBC <span class="font-normal">by Gwnn</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#453302",
  "field": "#5F625A",
  "highlight": "#FF7C00",
  "point_b": "#230057",
  "point_w": "#ffa742",
  "stone_b": "#ff5900",
  "stone_w": "#71fefc"
}
</pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/ubc_gwnn.png">
    </div>
</div>

<div>
    <h2>
        Calvino <span class="font-normal">by Davidklausa</span>
    </h2>
    <div class="flex justify-between items-center">
    <pre>
{
  "case": "#1E2129",
  "field": "#118885",
  "highlight": "#FF7C00",
  "point_b": "#676679",
  "point_w": "#e3e2b3",
  "stone_b": "#012c8d",
  "stone_w": "#fae974"
}
</pre>
    <img class="shrink h-48" src="@/assets/images/boardprofiles/calvino_davidklausa.png">
    </div>
</div>
</div>
</template>

<style scoped>
    h1 {
        @apply font-bold text-2xl mt-8 lg:text-4xl;
    }
    h2 {
        @apply font-semibold text-2xl mt-4 mb-2;
    }
    h3 {
        @apply font-semibold text-lg mt-4;
    }
    a {
        @apply text-point-b-color underline;
    }
</style>
